import { CustomError } from '../../../lib/custom-error';
import { LastPageModel } from '../../LastPageView';
import { SingleSelectModel, MultiSelectModel, GraphicSelectModel, GraphicSelectNumModel, TextModel, MatrixModel } from '../../QuestionView';
import { type Question, type Relation, QuestionType, AnswerType } from '../../types';
import type { QuestionModel } from '../QuestionModel';
import type { Survey } from '../Survey';

export class UnknownAnswerTypeError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}

export const createQuestionModel = (survey: Survey, question: Question, suitableRelation?: Relation | null): QuestionModel => {
  if (question.question_type === QuestionType.LastPage) {
    return new LastPageModel(survey, question, suitableRelation);
  }

  switch (question.answer_type) {
    case AnswerType.SingleSelect:
      return new SingleSelectModel(survey, question, suitableRelation);
    case AnswerType.MultiSelect:
      return new MultiSelectModel(survey, question, suitableRelation);
    case AnswerType.GraphicSelect:
      return new GraphicSelectModel(survey, question, suitableRelation);
    case AnswerType.GraphicSelectNum:
      return new GraphicSelectNumModel(survey, question, suitableRelation);
    case AnswerType.Text:
      return new TextModel(survey, question, suitableRelation);
    case AnswerType.Matrix:
      return new MatrixModel(survey, question, suitableRelation);
    default:
      throw new UnknownAnswerTypeError(question.answer_type);
  }
};
